const successSubtleLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5"/><polyline stroke-width="1.5" points="8.05 11.64 11.11 14.83 16.55 9.17"/></svg>',
};

export { successSubtleLarge as default };
